export * from '@firebase/remote-config';